<template>
  <div class="app-tag-view-item-model" :class="{active:isActiveUrl}" @click.stop="onToPath($event,item)" :id="id">
    <span :data-path="item.path">{{title}} <span v-if="num > 0">({{num}})</span></span>
    <b @click.stop="onClose"><i class="el-icon-circle-close"></i></b>
  </div>
</template>
<script>
  import Ps from '@/module/ps'
  import { mapActions, mapState, mapMutations } from 'vuex'
  export default {
    name: 'tag-view-item',
    data () {
      return {}
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      index: {
        type: Number,
        default: 0
      }
    },
    methods: {
      ...mapActions('common', ['removeTagViewList']),
      ...mapMutations('common', ['setCurrentTagItem', 'setArrTagViewList']),
      onToPath (e, item) {
        const { system, path, query } = item
        let pPath = ''
        let $path = system === 'app' ? path : `/${system}${path}`
        let params = Ps.handlerQuery(query)
        if (!_.isEmpty(item.pQuery)) {
          const { pName, pValue } = item.pQuery
          pPath = _.replace($path, pName, pValue)
        } else {
          pPath = `${$path}`
        }
        this.$router.push(`${pPath}${params}`)
        this.setCurrentTagItem(item)
        this.$emit('on-tag-toggle', item)
      },
      onClose () {
        const { tagViewList, index } = this
        // single tag view
        if (index === 0 && _.size(tagViewList) === 1) {
          this.setArrTagViewList([])
          this.$router.push(`/home`)
          return
        }

        let item = {}
        const nextItem = tagViewList[index + 1]

        if (_.isEmpty(nextItem)) {
          const i = index - 1
          const vItem = tagViewList[i]
          item = vItem
        } else {
          item = nextItem
        }
        const itemList = _.filter(tagViewList, (v, i) => i !== index)
        this.setArrTagViewList(itemList)
        this.onToPath({}, item)
      }
    },
    watch: {
    },
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['currentTagItem', 'tagViewList']),
      id () {
        const { name, query } = this.item
        let params = Ps.handlerQuery(query, true)
        return `${name}-${params}`
      },
      num () {
        const t = _.map(this.tagViewList, v => {
          return {
            ...v,
            pathParams: `${v.path}${Ps.handlerQuery(v.query)}`
          }
        })
        return _.findIndex(_.filter(t, ['path', this.item.path]), ['pathParams', `${this.item.path}${Ps.handlerQuery(this.item.query)}`])
      },
      title () {
        if (_.isEmpty(this.item) || _.isEmpty(this.item.meta) || _.isEmpty(this.item.meta.title)) {
          return 'No Title'
        } else {
          return this.item.meta.title
        }
      },
      isActiveUrl () {
        const { query } = this.currentTagItem
        const itemQuery = this.item.query
        const phQuery = Ps.handlerQuery(query)
        const phItemQuery = Ps.handlerQuery(itemQuery)

        // 处理参数 aaa/aaa?a=1&b=1
        if (_.isEmpty(this.currentTagItem.pQuery)) {
          return (phQuery === phItemQuery)
            ? this.currentTagItem.path === this.item.path
            : `${this.currentTagItem.path}${phQuery}` === `${this.currentTagItem.path}${phItemQuery}`
        } else {
          // 处理参数 aaa/:id
          const pPath = `${this.currentTagItem.path}/${this.currentTagItem.pQuery.pValue}`
          const pItemPath = `${this.item.path}/${this.item.pQuery.pValue}`
          return pPath === pItemPath
        }
      }
    }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  .app-tag-view-item-model {
    display: inline-block;
    position: relative;
    cursor: pointer;
    height: 32px;
    line-height: 32px;
    border: 1px solid #e8eaec;
    color: #515a6e;
    background: #fff;
    padding: 0 12px;
    font-size: 12px;
    margin: 2px 4px 2px 0;
    &::before {
      content: '';
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 8px;
      border-radius: 50%;
      background: #e8eaec;
      position: relative;
      top: 1px;
    }
    &.active {
      color: #2d8cf0;
      &::before {
        content: '';
        background: #2d8cf0;
      }
    }
    > b {
      margin-left: 8px;
      color: #777;
      font-weight: normal;
      font-size: 14px;
      vertical-align: top;
      position: relative;
      z-index: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/tagViewItem.vue